const PROJECTS = [
  {
    id: 'maintenance-system',
    title: 'Maintenance Management System',
    shortDescription:
      'SARR Maintenance World connects clients, field workers, subcontractors, and executives in one unified digital ecosystem.',
    detailedExplanation:
      'SARR Maintenance World connects clients, field workers, subcontractors, and executives through a unified digital ecosystem. The CEO oversees all operations; CHO, COO, CFO, and CMO each manage their domain with scoped access. Staff can submit payroll, request leave, and communicate via the built-in chat box in French or English, switchable at any time. Clients are managed through dedicated forms, invoices are generated and tracked, and subcontractor records are maintained alongside internal personnel files.',
    techStack: [
      'ASP.NET MVC',
      'SQL Server',
      'SignalR',
      'Localizer resource files (multi-language support)',
    ],
    thumbnail: '/projects/maintenance-system/maintenance1.png',
    imagePattern: '/projects/maintenance-system/maintenance{n}.png',
    imageCount: 3,
    demoUrl: 'https://www.loom.com/share/3416541639ce4ee586aae9debc096252',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
  {
    id: 'payments-suite',
    title: 'Goalbi',
    shortDescription:
      'Goalbi is a full-featured e-learning and tutoring platform with Student, Tutor, and Admin portals in one role-based system.',
    detailedExplanation:
      'Goalbi connects students and tutors through a unified digital ecosystem. Students can discover tutors, check real-time slots, book one-on-one sessions, enroll in courses, and join live classes via Zoom. Tutors manage availability, schedules, session delivery, earnings, and withdrawal requests. Admins monitor platform activity, transactions, and overall integrity while approving tutor withdrawals. Payments are processed securely via Stripe and PayPal, credited to tutor balances, and released after admin approval. The platform uses a modular multi-portal architecture for maintainability and scale.',
    techStack: [
      'Angular',
      '.NET',
      'Stripe',
      'PayPal',
      'Zoom API',
      'Role-based multi-portal architecture',
    ],
    subtitle: 'Payments & Subscription Suite • Student Portal • Tutor Portal • Admin Portal',
    thumbnail: '/projects/payments/goalbi1.jpeg',
    imagePattern: '/projects/payments/goalbi{n}.jpeg',
    imageCount: 3,
    demoUrl: 'https://drive.google.com/file/d/1SLqzBdI74BnbOSOh_yEBf9sfWV7DY-al/view?usp=sharing',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
  {
    id: 'healthcare-portal',
    title: 'Veridian',
    shortDescription:
      'Company management system for employee operations, project allocation, timesheet tracking, and financial processing.',
    detailedExplanation:
      'Veridian streamlines internal operations including employee management, project allocation, timesheet tracking, and financial processing. Project managers assign tasks to employees, who log working hours through timesheets. At the end of each billing cycle, submitted timesheets are reviewed and converted into billable client data. The platform supports rate management, discounts, licensing, and adjustments for accurate billing and invoice generation across multiple clients and projects. It also includes service listings, document management, and project-related media storage, providing a centralized end-to-end operations platform that improves transparency, efficiency, and control.',
    techStack: ['Angular', '.NET', 'SQL Server', 'Azure'],
    subtitle: 'Company Management System • Timesheets • Billing • Operations',
    thumbnail: '/projects/veridian/verdian1.jpeg',
    imagePattern: '/projects/veridian/verdian{n}.jpeg',
    imageCount: 4,
    demoUrl: 'https://drive.google.com/file/d/1DWDTXo1eiUWcz2_yIVee8lq-5_Hqt2rc/view?usp=sharing',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
  {
    id: 'logistics-dashboard',
    title: 'DANUBEE',
    shortDescription:
      'Grocery delivery mobile app for ordering daily essentials with real-time tracking and flexible delivery scheduling.',
    detailedExplanation:
      'DANUBEE is a grocery delivery mobile application designed to provide users with a seamless and convenient way to order daily essentials directly to their doorstep. The app is built using React Native, with Firebase for real-time tracking and Node.js for backend services. Users can browse products, add items to cart, and place orders by selecting their delivery location. It supports flexible delivery scheduling with specific time slots and future dates, including same-day and next-day delivery. The app includes Google login integration for fast and secure access, and users can add special delivery instructions for riders. The system also manages delivery workers efficiently, ensuring smooth coordination between users, riders, and backend operations for timely order fulfillment. Overall, DANUBEE delivers a modern, user-friendly grocery ordering experience with real-time tracking, scheduling flexibility, and efficient delivery management.',
    techStack: ['React Native', 'Firebase', 'Node.js', 'Google Login'],
    subtitle: 'Grocery Delivery App • Real-time Tracking • Scheduled Delivery',
    thumbnail: '/projects/danubee/danubee1.jpeg',
    imagePattern: '/projects/danubee/danubee{n}.jpeg',
    imageCount: 3,
    demoUrl: 'https://drive.google.com/file/d/1GVd780MRTdOhK1xzUbctcNF3Y1ykyqsW/view?usp=sharing',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
  {
    id: 'glovr-party-game',
    title: 'Glovr',
    shortDescription:
      'Fast and fun party game app for friends to play instantly on a single phone with zero setup.',
    detailedExplanation:
      'Glovr is a fast and fun party game app designed for friends to enjoy together on a single phone. It turns any hangout into an instant party with quick, interactive mini-games that require no setup, accounts, or learning curve. Players simply open the app, pass the phone around, and start playing exciting group challenges that spark laughter, competition, and social fun. It is perfect for house parties, game nights, pre-games, or casual hangouts. The app is built for simplicity and entertainment, offering instant gameplay with replayable mini-games and a clean, modern interface. No sign-up is required, making it easy for anyone to jump in and enjoy.',
    techStack: [
      'Flutter',
      'Google Ads integration',
      'Google Play Store (published live app)',
    ],
    subtitle: 'Party Game App • Single-Phone Multiplayer • Instant Gameplay',
    thumbnail: '/projects/glovr/glovr1.jpeg',
    imagePattern: '/projects/glovr/glovr{n}.jpeg',
    imageCount: 3,
    demoUrl: 'https://drive.google.com/file/d/1Jdpvdnzc0WT8jpnQUu4JRR9rQly8D_US/view?usp=sharing',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
  {
    id: 'byopar-pos-inventory',
    title: 'Byopar',
    shortDescription:
      'Web-based POS and inventory platform that digitizes billing, stock, CRM, purchasing, and financial control across branches.',
    detailedExplanation:
      'Problem Statement: Retail and wholesale businesses were struggling with manual billing, Excel-based inventory, and disconnected records, causing billing delays, stock discrepancies, no real-time sales visibility, and no insight into profit margins or customer dues. Managing purchase orders, supplier payments, and daily cash flow had become a daily headache. Solution: I designed and developed a complete web-based POS system to digitize and automate end-to-end business operations from a single platform, replacing manual processes with a fast, reliable, and user-friendly experience for non-technical users. Key Features: Sales and Purchase Operations with Sales Orders and Purchase Orders, automated stock deduction, tax calculation, discounts, returns/refunds, and professional invoice printing; Inventory Management with real-time product master, barcode support, stock alerts, batch/expiry tracking, and multi-location warehouse control; Customer and Supplier CRM with complete profiles, ledgers, outstanding balances, payment history, and transaction tracking; Financial Control with multi-payment modes, cash register management, daily sales summaries, and closing reports; Interactive Dashboard with role-based analytics for revenue trends, top-selling products, profit margins, low-stock alerts, and business KPIs. Impact: Reduced average billing time by 70%, eliminated stock discrepancies through automated updates, and enabled data-driven decisions with real-time dashboards. The system currently handles 500+ daily transactions across multiple branches. Role: Full-stack development - architected the database schema, built secure .NET Core APIs, developed responsive Angular UI, and implemented reporting plus barcode integration.',
    techStack: [
      '.NET Core',
      'Angular',
      'SQL Server',
      'REST APIs',
      'JWT Authentication',
    ],
    subtitle: 'POS & Inventory Management • Billing • CRM • Financial Analytics',
    thumbnail: '/projects/byopar/byopar-1.jpeg',
    imagePattern: '/projects/byopar/byopar-{n}.jpeg',
    imageCount: 4,
    demoUrl: 'https://drive.google.com/file/d/1XUXYfcf0WnuTTW9DOA4CUnkFcCQpiNr3/view?usp=sharing',
    liveUrl: '',
    githubUrl: '',
    videoFileUrl: '',
  },
];

const MIN_IMAGE_ZOOM = 1;
const MAX_IMAGE_ZOOM = 3;
const IMAGE_ZOOM_STEP = 0.25;

function clampZoom(value) {
  return Math.min(MAX_IMAGE_ZOOM, Math.max(MIN_IMAGE_ZOOM, value));
}

function toLoomEmbedUrl(url) {
  if (!url) return null;
  const raw = String(url).trim();
  const match = raw.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
  if (!match) return null;
  return `https://www.loom.com/embed/${match[1]}`;
}

function toYoutubeEmbedUrl(url) {
  if (!url) return null;
  const raw = String(url).trim();
  const match = raw.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{6,})/
  );
  if (!match) return null;
  return `https://www.youtube.com/embed/${match[1]}`;
}

function hasRecordedVideo(project) {
  const url = project?.videoFileUrl || project?.recordedVideoUrl || project?.demoVideoUrl;
  return Boolean(url && String(url).trim());
}

function getRecordedVideoUrl(project) {
  const url = project?.videoFileUrl || project?.recordedVideoUrl || project?.demoVideoUrl;
  return url ? String(url).trim() : '';
}

function isProbablyPlaceholderUrl(url) {
  if (!url) return true;
  const u = String(url).trim();
  if (!u || u === '#') return true;
  return /example\.com/i.test(u);
}

function getProjectDemoUrl(project) {
  const loom = project?.demoUrl || project?.loomShareUrl || project?.loomEmbedUrl;
  if (loom) return String(loom).trim();

  const live = project?.liveUrl;
  if (live && !isProbablyPlaceholderUrl(live)) return String(live).trim();

  const recorded = getRecordedVideoUrl(project);
  if (recorded) return recorded;

  return '';
}

function getProjectImages(project) {
  if (project?.imagePattern && Number.isInteger(project?.imageCount) && project.imageCount > 0) {
    return Array.from({ length: project.imageCount }, (_, idx) =>
      String(project.imagePattern).replace('{n}', String(idx + 1))
    );
  }

  if (Array.isArray(project?.images) && project.images.length) return project.images;
  if (project?.thumbnail) return [project.thumbnail];
  return [];
}

function makeProjectSubtitle(project) {
  if (project?.subtitle) return project.subtitle;
  const tags = Array.isArray(project?.techStack) ? project.techStack.slice(0, 4) : [];
  return tags.join(' • ');
}

function buildProjectCardMarkup(project, idx) {
  const images = getProjectImages(project);
  const imageSrc = images[0] || '';
  const imageAlt = `${project.title} preview`;
  const hasDemo = Boolean(getProjectDemoUrl(project));
  const showCarousel = images.length > 1;
  const techPreview = (project.techStack || []).slice(0, 4);
  const delay = idx * 70;
  const animationKind = ['fade-up', 'zoom-in', 'fade-in'][idx % 3];

  const dotsMarkup = showCarousel
    ? `
      <div class="project-media-dots" aria-label="${project.title} images">
        ${images
          .map(
            (_, imageIdx) => `
              <button
                type="button"
                class="project-media-dot"
                data-project-carousel-dot="${project.id}"
                data-index="${imageIdx}"
                aria-current="${imageIdx === 0 ? 'true' : 'false'}"
                aria-label="View image ${imageIdx + 1}"
              ></button>
            `
          )
          .join('')}
      </div>
    `
    : '';

  return `
    <article
      class="project-card"
      role="button"
      tabindex="0"
      data-project-open="${project.id}"
      data-project-id="${project.id}"
      data-has-demo="${hasDemo ? 'true' : 'false'}"
      data-animate="${animationKind}"
      data-delay="${delay}"
    >
      <div class="project-media">
        <img
          src="${imageSrc}"
          width="1200"
          height="800"
          loading="lazy"
          decoding="async"
          alt="${imageAlt}"
          data-project-card-image="${project.id}"
        />
        <span class="project-watch" aria-hidden="true">Watch demo</span>
        ${
          showCarousel
            ? `
              <button
                class="project-media-nav prev"
                type="button"
                data-project-carousel-control="${project.id}"
                data-direction="prev"
                aria-label="Previous image"
              >←</button>
              <button
                class="project-media-nav next"
                type="button"
                data-project-carousel-control="${project.id}"
                data-direction="next"
                aria-label="Next image"
              >→</button>
            `
            : ''
        }
      </div>
      <div class="project-body">
        <h3 class="project-title">${project.title}</h3>
        <p class="project-desc">${project.shortDescription || ''}</p>
        <p class="project-sub">${makeProjectSubtitle(project)}</p>
        <div class="project-tags" aria-label="Tech stack">
          ${techPreview.map((item) => `<span class="tech-chip">${item}</span>`).join('')}
        </div>
        <div class="project-actions" aria-label="Project actions">
          <a
            class="btn btn-secondary project-demo-btn"
            href="${hasDemo ? getProjectDemoUrl(project) : '#'}"
            ${hasDemo ? 'target="_blank" rel="noopener noreferrer"' : 'aria-disabled="true"'}
            data-project-demo-link="${project.id}"
          >Watch Demo</a>
          <button class="btn btn-secondary project-details-btn" type="button" data-project-open="${project.id}">
            View Details
          </button>
        </div>
        ${dotsMarkup}
      </div>
    </article>
  `;
}

function initPortfolioSlider(projectsGrid) {
  if (!projectsGrid) return;

  const sliderRoot = document.querySelector('[data-portfolio-slider]');
  const viewport = sliderRoot?.querySelector('[data-portfolio-slider-viewport]');
  const prevBtn = sliderRoot?.querySelector('[data-portfolio-slider-prev]');
  const nextBtn = sliderRoot?.querySelector('[data-portfolio-slider-next]');
  const counterEl = sliderRoot?.querySelector('[data-portfolio-counter]');
  if (!sliderRoot || !viewport || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  const gap = 20;
  let cardWidth = 0;
  let perView = 1;
  let maxIndex = 0;

  const getCards = () => Array.from(projectsGrid.querySelectorAll('.project-card'));

  const getPerView = () => {
    const width = window.innerWidth;
    if (width >= 1100) return 3;
    if (width >= 768) return 2;
    return 1;
  };

  const update = () => {
    const cards = getCards();
    if (!cards.length) return;

    perView = Math.min(getPerView(), cards.length);
    cardWidth = (viewport.clientWidth - gap * (perView - 1)) / perView;
    maxIndex = Math.max(0, cards.length - perView);

    currentIndex = Math.max(0, Math.min(currentIndex, maxIndex));

    cards.forEach((card) => {
      card.style.flex = `0 0 ${cardWidth}px`;
    });

    const translateX = currentIndex * (cardWidth + gap);
    projectsGrid.style.transform = `translateX(-${translateX}px)`;

    prevBtn.disabled = currentIndex <= 0;
    nextBtn.disabled = currentIndex >= maxIndex;

    if (counterEl) {
      const start = currentIndex + 1;
      const end = Math.min(currentIndex + perView, cards.length);
      counterEl.textContent =
        start === end ? `${start} / ${cards.length}` : `${start}–${end} / ${cards.length}`;
    }
  };

  prevBtn.addEventListener('click', () => {
    currentIndex -= 1;
    update();
  });

  nextBtn.addEventListener('click', () => {
    currentIndex += 1;
    update();
  });

  let dragStartX = 0;
  let dragDeltaX = 0;
  let dragging = false;

  const getTranslateForIndex = (index) => index * (cardWidth + gap);

  const onDragStart = (clientX) => {
    dragging = true;
    dragStartX = clientX;
    dragDeltaX = 0;
    projectsGrid.style.transition = 'none';
  };

  const onDragMove = (clientX) => {
    if (!dragging) return;
    dragDeltaX = clientX - dragStartX;
    const base = getTranslateForIndex(currentIndex);
    projectsGrid.style.transform = `translateX(-${Math.max(0, base - dragDeltaX)}px)`;
  };

  const onDragEnd = () => {
    if (!dragging) return;
    dragging = false;
    projectsGrid.style.transition = '';

    const threshold = Math.max(44, cardWidth * 0.14);
    if (dragDeltaX > threshold) currentIndex -= 1;
    if (dragDeltaX < -threshold) currentIndex += 1;
    update();
  };

  viewport.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    onDragStart(e.clientX);
  });
  viewport.addEventListener('pointermove', (e) => onDragMove(e.clientX));
  viewport.addEventListener('pointerup', onDragEnd);
  viewport.addEventListener('pointercancel', onDragEnd);
  viewport.addEventListener('pointerleave', onDragEnd);

  window.addEventListener('resize', update);
  update();
}

function getFocusable(container) {
  if (!container) return [];
  const selectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'textarea:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ];
  return Array.from(container.querySelectorAll(selectors.join(','))).filter(
    (el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true'
  );
}

export function initPortfolioModal() {
  const projectsGrid = document.querySelector('[data-projects-grid]');
  if (projectsGrid) {
    projectsGrid.innerHTML = PROJECTS.map((project, idx) => buildProjectCardMarkup(project, idx)).join('');
    initPortfolioSlider(projectsGrid);
  }

  const modal = document.querySelector('[data-project-modal]');
  if (!modal) return;

  const closeEls = Array.from(modal.querySelectorAll('[data-project-modal-close]'));
  const titleEl = modal.querySelector('#project-modal-title');
  const subEl = modal.querySelector('[data-project-modal-sub]');
  const descEl = modal.querySelector('[data-project-modal-desc]');
  const detailedEl = modal.querySelector('[data-project-modal-detailed]');
  const detailedRoot = modal.querySelector('[data-project-modal-more]');
  const techRoot = modal.querySelector('[data-project-modal-tech]');
  const mediaRoot = modal.querySelector('[data-project-modal-media]');
  const galleryRoot = modal.querySelector('[data-project-modal-gallery]');
  const watchLink = modal.querySelector('[data-project-watch]');
  const liveLink = modal.querySelector('[data-project-live]');
  const githubLink = modal.querySelector('[data-project-github]');

  let lastActiveElement = null;
  let activeProjectId = null;
  let activeImageIndex = 0;
  let activeMediaMode = 'demo';
  let activeImageZoom = 1;
  const cardImageIndexes = new Map(PROJECTS.map((project) => [project.id, 0]));

  const setOpen = (open) => {
    modal.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';

    if (open) {
      lastActiveElement = document.activeElement;
      const closeBtn = modal.querySelector('.modal-close');
      if (closeBtn) closeBtn.focus();
    } else {
      // Clean up media (pause video)
      if (mediaRoot) mediaRoot.innerHTML = '';
      if (galleryRoot) galleryRoot.innerHTML = '';
      if (techRoot) techRoot.innerHTML = '';
      if (detailedRoot) {
        detailedRoot.hidden = true;
        detailedRoot.open = false;
      }

      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }

      lastActiveElement = null;
      activeProjectId = null;
      activeImageZoom = 1;
    }
  };

  const renderMedia = (project) => {
    if (!mediaRoot) return;
    mediaRoot.classList.remove('media-fade-in');
    void mediaRoot.offsetWidth;
    mediaRoot.classList.add('media-fade-in');

    const loomEmbedUrl = toLoomEmbedUrl(project.demoUrl || project.loomShareUrl || project.loomEmbedUrl);
    const youtubeEmbedUrl = toYoutubeEmbedUrl(project.demoUrl);
    const hasEmbedDemo = Boolean(loomEmbedUrl || youtubeEmbedUrl);
    const hasFileDemo = hasRecordedVideo(project);
    const hasDemo = hasEmbedDemo || hasFileDemo;

    if (hasDemo && activeMediaMode === 'demo') {
      if (hasEmbedDemo) {
        const embedUrl = loomEmbedUrl || youtubeEmbedUrl;
        mediaRoot.innerHTML = `
          <iframe
            class="loom-embed"
            src="${embedUrl}"
            title="${project.title} demo"
            allow="autoplay; fullscreen; clipboard-write; picture-in-picture"
            allowfullscreen
          ></iframe>
        `;
      } else {
        const src = getRecordedVideoUrl(project);
        mediaRoot.innerHTML = `
          <video controls playsinline preload="metadata" ${project.thumbnail ? `poster="${project.thumbnail}"` : ''}>
            <source src="${src}" />
            Your browser does not support the video tag.
          </video>
        `;
      }
      return;
    }

    const images = getProjectImages(project);
    const initialSrc = images[activeImageIndex] || images[0];
    const zoomPercent = Math.round(activeImageZoom * 100);
    mediaRoot.innerHTML = `
      <div class="project-zoom-shell">
        <div class="project-zoom-toolbar" aria-label="Image zoom controls">
          <button
            type="button"
            class="project-zoom-btn"
            data-project-zoom="out"
            aria-label="Zoom out"
            ${activeImageZoom <= MIN_IMAGE_ZOOM ? 'disabled' : ''}
          >−</button>
          <span class="project-zoom-level">${zoomPercent}%</span>
          <button
            type="button"
            class="project-zoom-btn"
            data-project-zoom="in"
            aria-label="Zoom in"
            ${activeImageZoom >= MAX_IMAGE_ZOOM ? 'disabled' : ''}
          >+</button>
          <button type="button" class="project-zoom-btn" data-project-zoom="reset" aria-label="Reset zoom">Reset</button>
        </div>
        <div class="project-zoom-stage">
          <img
            src="${initialSrc}"
            alt="${project.title} screenshot"
            loading="lazy"
            data-project-full-image="${initialSrc}"
            style="width:${zoomPercent}%; max-width:none; height:auto;"
          />
        </div>
      </div>
    `;
  };

  const renderGallery = (project) => {
    if (!galleryRoot) return;

    const images = getProjectImages(project).slice(0, 8);

    galleryRoot.innerHTML = images
      .map((src, idx) => {
        const current = idx === activeImageIndex ? 'true' : 'false';
        return `
          <button class="gallery-thumb" type="button" data-project-image="${idx}" aria-current="${current}" aria-label="View screenshot ${idx + 1}">
            <img src="${src}" alt="" loading="lazy" />
          </button>
        `;
      })
      .join('');
  };

  const renderTech = (project) => {
    if (!techRoot) return;
    const tech = Array.isArray(project.techStack) ? project.techStack : [];
    techRoot.innerHTML = tech.length
      ? tech.map((t) => `<span class="tech-chip">${t}</span>`).join('')
      : '';
  };

  const openFor = (projectId) => {
    const project = PROJECTS.find((p) => p.id === projectId);
    if (!project) return;

    activeProjectId = project.id;
    activeImageIndex = 0;
    activeImageZoom = 1;
    activeMediaMode =
      toLoomEmbedUrl(project.demoUrl || project.loomShareUrl || project.loomEmbedUrl) ||
      toYoutubeEmbedUrl(project.demoUrl) ||
      hasRecordedVideo(project)
        ? 'demo'
        : 'image';

    if (titleEl) titleEl.textContent = project.title;
    if (subEl) subEl.textContent = makeProjectSubtitle(project);
    if (descEl) descEl.textContent = project.shortDescription || '';
    if (detailedEl) detailedEl.textContent = project.detailedExplanation || '';
    if (detailedRoot) detailedRoot.hidden = !project.detailedExplanation;

    if (watchLink) {
      const demoUrl = getProjectDemoUrl(project);
      if (demoUrl) {
        watchLink.setAttribute('href', demoUrl);
        watchLink.style.display = '';
      } else {
        watchLink.removeAttribute('href');
        watchLink.style.display = 'none';
      }
    }

    if (liveLink) {
      if (project.liveUrl && !isProbablyPlaceholderUrl(project.liveUrl)) {
        liveLink.setAttribute('href', project.liveUrl);
        liveLink.style.display = '';
        liveLink.removeAttribute('aria-disabled');
        liveLink.style.pointerEvents = '';
        liveLink.style.opacity = '';
      } else {
        liveLink.removeAttribute('href');
        liveLink.style.display = 'none';
      }
    }

    if (githubLink) {
      if (project.githubUrl) {
        githubLink.setAttribute('href', project.githubUrl);
        githubLink.style.display = '';
      } else {
        githubLink.removeAttribute('href');
        githubLink.style.display = 'none';
      }
    }

    renderTech(project);
    renderMedia(project);
    renderGallery(project);

    setOpen(true);
  };

  const syncImageSelection = () => {
    if (!activeProjectId) return;
    const project = PROJECTS.find((p) => p.id === activeProjectId);
    if (!project) return;

    renderMedia(project);

    const thumbButtons = Array.from(modal.querySelectorAll('[data-project-image]'));
    thumbButtons.forEach((btn) => {
      const idx = Number(btn.getAttribute('data-project-image'));
      btn.setAttribute('aria-current', idx === activeImageIndex ? 'true' : 'false');
    });
  };

  const setCardImage = (projectId, nextIdx) => {
    const project = PROJECTS.find((item) => item.id === projectId);
    if (!project) return;
    const images = getProjectImages(project);
    if (!images.length) return;

    const normalized = ((nextIdx % images.length) + images.length) % images.length;
    cardImageIndexes.set(projectId, normalized);

    const imageEl = document.querySelector(`[data-project-card-image="${projectId}"]`);
    if (imageEl) imageEl.setAttribute('src', images[normalized]);

    const dots = Array.from(
      document.querySelectorAll(`[data-project-carousel-dot="${projectId}"]`)
    );
    dots.forEach((dot) => {
      const idx = Number(dot.getAttribute('data-index'));
      dot.setAttribute('aria-current', idx === normalized ? 'true' : 'false');
    });
  };

  // Open handler (event delegation)
  document.addEventListener('click', (e) => {
    const target = e.target;
    if (!target) return;

    const carouselControl = target.closest('[data-project-carousel-control]');
    if (carouselControl) {
      e.preventDefault();
      e.stopPropagation();
      const id = carouselControl.getAttribute('data-project-carousel-control');
      const direction = carouselControl.getAttribute('data-direction');
      if (!id) return;
      const current = cardImageIndexes.get(id) || 0;
      const nextIdx = direction === 'prev' ? current - 1 : current + 1;
      setCardImage(id, nextIdx);
      return;
    }

    const carouselDot = target.closest('[data-project-carousel-dot]');
    if (carouselDot) {
      e.preventDefault();
      e.stopPropagation();
      const id = carouselDot.getAttribute('data-project-carousel-dot');
      const idx = Number(carouselDot.getAttribute('data-index'));
      if (!id || Number.isNaN(idx)) return;
      setCardImage(id, idx);
      return;
    }

    const demoBtn = target.closest('[data-project-demo-link]');
    if (demoBtn) {
      const id = demoBtn.getAttribute('data-project-demo-link');
      const project = id ? PROJECTS.find((p) => p.id === id) : null;
      const demoUrl = project ? getProjectDemoUrl(project) : '';

      if (demoBtn.getAttribute('aria-disabled') === 'true' || !demoUrl) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
      return;
    }

    const openBtn = target.closest('[data-project-open]');
    if (openBtn) {
      const id = openBtn.getAttribute('data-project-open');
      if (id) openFor(id);
    }
  });

  // Keyboard open (Enter/Space) for focusable cards
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const el = document.activeElement;
    if (!el || typeof el.closest !== 'function') return;

    // Don’t override default behavior when focused on a real control.
    if (el.matches('a, button, input, textarea, select')) return;

    const openEl = el.closest('[data-project-open]');
    if (!openEl) return;

    const id = openEl.getAttribute('data-project-open');
    if (!id) return;

    e.preventDefault();
    openFor(id);
  });

  // Gallery click
  modal.addEventListener('click', (e) => {
    const target = e.target;
    if (!target) return;

    const thumb = target.closest('[data-project-image]');
    if (thumb) {
      const idx = Number(thumb.getAttribute('data-project-image'));
      if (!Number.isNaN(idx)) {
        activeImageIndex = idx;
        activeImageZoom = 1;
        activeMediaMode = 'image';
        syncImageSelection();
      }
      return;
    }

    const zoomControl = target.closest('[data-project-zoom]');
    if (zoomControl) {
      const action = zoomControl.getAttribute('data-project-zoom');
      if (!action || !activeProjectId) return;
      const project = PROJECTS.find((p) => p.id === activeProjectId);
      if (!project) return;

      if (action === 'in') activeImageZoom = clampZoom(activeImageZoom + IMAGE_ZOOM_STEP);
      if (action === 'out') activeImageZoom = clampZoom(activeImageZoom - IMAGE_ZOOM_STEP);
      if (action === 'reset') activeImageZoom = 1;

      activeMediaMode = 'image';
      renderMedia(project);
      return;
    }

    const fullImage = target.closest('[data-project-full-image]');
    if (fullImage) {
      const src = fullImage.getAttribute('data-project-full-image') || fullImage.getAttribute('src');
      if (!src) return;
      window.open(src, '_blank', 'noopener,noreferrer');
    }
  });

  // Close buttons
  for (const el of closeEls) el.addEventListener('click', () => setOpen(false));

  // ESC + focus trap
  window.addEventListener('keydown', (e) => {
    const isOpen = modal.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    if (e.key === 'Escape') {
      setOpen(false);
      return;
    }

    if (e.key !== 'Tab') return;

    const focusables = getFocusable(modal);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
      return;
    }

    if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}
